export default "__VITE_ASSET__JHq33eJV__"